'use client'

import { cn } from '@/lib/utils'
import { Icons } from '@/components/ui/icons'
import { useTranslations } from 'use-intl'

interface Props {
  prompts: string[]
  onSelect: (prompt: string) => void
  disabled?: boolean
}

/** Follow-up chips rendered under the last assistant message (C2 suggested_prompts). */
export function SuggestedPrompts({ prompts, onSelect, disabled }: Props) {
  const t = useTranslations('aiPanel.suggestedPrompts')
  if (!prompts.length) return null
  return (
    <div className="flex flex-wrap gap-1.5 pl-1" aria-label={t('label')}>
      {prompts.slice(0, 4).map((p, i) => (
        <button
          key={`${i}-${p}`}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(p)}
          className={cn(
            'inline-flex items-center gap-1 rounded-full border border-brand-cornflower/30 bg-white px-2.5 py-1',
            'text-xs text-brand-navy transition-colors hover:bg-brand-cornflower/10 disabled:opacity-50',
            'focus:outline-none focus:ring-2 focus:ring-brand-cornflower/40'
          )}
        >
          <Icons.sparkles className="h-3 w-3 text-brand-cornflower" strokeWidth={1.5} />
          {p}
        </button>
      ))}
    </div>
  )
}
